import Clarity from '@microsoft/clarity';
import { getCookie } from 'helpers/cookie';
import { type HotjarUser, setHotjarUser } from 'hotjar';
import logService from 'services/log';
import { type User } from 'services/user/types';
import { COOKIE_DOMAIN, EDUZZ_REGISTRY_VALID_KEY, IS_PROD } from 'settings';

const ONE_YEARS_IN_SECONDS = 60 * 60 * 24 * 365;

export function applyUserSessionSideEffects(user: User): void {
  const {
    cli_cod: id,
    user_email: email,
    user_name: name,
    belt,
    acpo_original_user_cli_cod,
    eduzz_registry_valid
  } = user;

  sessionStorage.setItem(EDUZZ_REGISTRY_VALID_KEY, String(eduzz_registry_valid));

  logService.setUser(user);
  setHotjarUser({
    id,
    email,
    name,
    belt,
    isAccessControl: id === acpo_original_user_cli_cod
  } as HotjarUser);

  if (IS_PROD) {
    Clarity.identify(id.toString());
  }

  const userCookie = getCookie('blk_user');

  if (!userCookie || (userCookie && userCookie !== user.id)) {
    document.cookie = `blk_user=${user?.id};domain=${COOKIE_DOMAIN};path=/;max-age=${ONE_YEARS_IN_SECONDS}`;
  }
}
